import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import debounce from 'lodash/debounce';

import Avatar from '@mui/material/Avatar';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import red from '@mui/material/colors/red';
import green from '@mui/material/colors/green';
import toast from 'react-hot-toast';
import Autocomplete from '@mui/material/Autocomplete';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import onBoardBasicBG from '../../assets/images/player-01.png';
import onBoardBasicBG2 from '../../assets/images/player-01_02.png';

import { ColoredButton } from '../../components/Buttons/colored';
import * as ROUTES from '../../constants/routes';
import ImageUpload from '../../components/Dialogs/imageUpload';
import {
  autoSuggestCities,
  fetchCities,
  fetchCountries,
  fetchLangs,
  fetchSports,
  uploadFile,
} from '../../store/actions/common';
import { gtPostActivity } from '../../store/actions/feed';
import {
  userOnBoardBasic,
  userOccupation,
  dispatchSetOccupation,
  dispatchRegistrationStart,
  dispatchRegistrationEnd,
} from '../../store/actions/register';
import {
  checkUri,
  updateUri,
  fetchUserDetails,
} from '../../store/actions/user';
import { receiveConnectRequests } from '../../store/actions/invite';
import { _lt } from '../../localization/locale';
import { uriRegEx } from '../../constants/regex';
import { getImage } from '../../utils/images';
import { localTrim } from '../../utils/strings';
import { checkDOBDateRange } from '../../utils/date';
import { loginOldSite } from '../../store/actions/auth';
import { Paper } from '@mui/material/';
import { useTheme } from '@mui/material/styles';
import { siteRoles } from '../../constants/common';

const OnBoardBasic = (props) => {
  const theme = useTheme();

  const classes = {
    root: {
      background:
        'linear-gradient(#d3cff620,#ffffff,#ffffff,#d3cff610,#d3cff620)',
      backgroundSize: 'cover',
      height: 'calc(100vh - 2rem)',
      overflow: 'scroll',
      [theme.breakpoints.down('xs')]: {
        background: 'white',
      },
    },
    formWrapper: {
      width: '100%',
      maxWidth: '1200px',
      height: 'max-content',
      margin: '80px 16px 16px',
      boxShadow: '0px 10px 16px #d3cff650',
      border: '1px solid #1f1f3320',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'row',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        margin: '80px 16px 16px',
      },
      [theme.breakpoints.down('sm')]: {
        margin: '0 0 0',
        border: 'none',
        borderRadius: '0',
        boxShadow: 'none',
      },
    },
    formImage: {
      width: '100%',
      background: `url(${onBoardBasicBG}) no-repeat center`,
      backgroundSize: 'cover',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '120px',
        background: `url(${onBoardBasicBG2}) no-repeat center`,
        backgroundSize: 'cover',
      },
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    formContents: {
      width: '100%',
      boxSizing: 'border-box',
      padding: '60px 60px',
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        padding: '60px 32px',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        padding: '10px 48px 60px 48px',
      },
      [theme.breakpoints.down('xs')]: {
        padding: '32px 24px',
      },
    },
    avatar: {
      margin: '16px 0px',
      [theme.breakpoints.down('xs')]: {
        alignItems: 'center',
      },
    },
    contentBox: {
      width: '100%',
      padding: '50px',
      [theme.breakpoints.down('sm')]: {
        padding: '32px',
      },
    },
    formControlInput: {
      borderRadius: '4px',
      backgroundColor: '#f1edff30',
    },
    submitButton: {
      width: '100%',
      backgroundColor: '#ff0000',
      //marginTop: '32px',
      borderRadius: '99px',
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
  };

  const [error, setError] = useState({});
  const [uri, setUri] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dataSubmit, setDataSubmit] = useState(false);
  const [checkingUri, setCheckingUri] = useState(false);
  const [uriError, setUriError] = useState(false);
  const [geonameId, setGeonameId] = useState(null);
  const [country, setCountry] = useState(null);
  const [stateName, setStateName] = useState('');
  const [avatarId, setAvatarId] = useState(null);
  const [gender, setGender] = useState('');
  const [sport, setSport] = useState('');
  const [sportName, setSportName] = useState('');
  const [bio, setBio] = useState('');
  const [lang, setLang] = useState('');
  const [avatar, setAvatar] = useState(null);
  const [showUploadDialog, setShowUploadDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);
  const [cityList, setCityList] = useState([]);
  const [cityName, setCityName] = useState('');
  const [dob, setDob] = useState('');
  const [msg, setMsg] = useState('One last step!');

  //https://dmitripavlutin.com/react-useeffect-explanation/
  useEffect(() => {
    async function fetchData() {
      if (
        !props.info ||
        (Object.keys(props.info).length > 0 && !props.info.hasOwnProperty('id'))
      ) {
        props.fetchUserDetails();
      }
      if (!props.countries) {
        props.fetchCountries();
      }
      if (!props.langs) {
        props.fetchLangs();
      }
      if (!props.sports) {
        props.fetchSports();
      }
    }
    fetchData();
    if (props.occupation) {
      if (props.occupation > 3)
        setMsg(
          'One last step before you can connect with thousands of verified athletes.',
        );
      else
        setMsg(
          'One last step before you can connect with hundreds of verified agents and scouts.',
        );
    }
  }, []);

  useEffect(async () => {
    console.log('props.info', props.info);
    if (!dataSubmit && props.info != null && props.info.hasOwnProperty('id')) {
      props.info.country_code && setCountry(props.info.country_code);
      props.info.avatar_id && setAvatarId(props.info.avatar_id);
      props.info.gender_val && setGender(props.info.gender_val);
      props.info.uri && setUri(props.info.uri);
      props.info.bio && setBio(props.info.bio);
      props.info.birthday && setDob(props.info.birthday);
      props.info.locale && setLang(props.info.locale);
      props.info.registration_sport_id &&
        setSport(props.info.registration_sport_id);
      props.info.registration_sport &&
        setSportName(props.info.registration_sport);
      setAvatar(getImage(props.info));
      props.info.geoname_id && setGeonameId(props.info.geoname_id);

      props.info.state_name && setStateName(props.info.state_name);
      const cities = await fetchCities(
        props.info.country_code,
        props.info.state_name,
      );
      setCityName(
        `${props.info.city_name}, ${props.info.state_name}, ${props.info.country_name}`,
      );
    }
  }, [props.info]);

  useEffect(() => {
    if (props.registrationStatus === 1) {
      setLoading(true);
      setDialogOpen(true);
    }
    if (props.registrationStatus === 2) {
      setLoading(false);
      setDialogOpen(false);
    }
  }, [props.registrationStatus]);

  const debouncedOnCityHandleChange = useMemo(
    () =>
      debounce(async (event) => {
        setLoadingCities(true);
        let searchQS = event.target.value;
        let newList = [];
        if (searchQS.length > 2) newList = await autoSuggestCities(searchQS);
        setCityList(newList || []);
        setLoadingCities(false);
      }, 500),
    [],
  );

  const onSubmit = (event) => {
    event.preventDefault();
    if (isInvalid) {
      toast.error(_lt('All fields are mandatory!'));
    } else if (avatarId === null) {
      toast.error(
        _lt(
          'Please upload your profile photo. Tap on the image icon on the top to do so',
        ),
      );
    } else {
      props.dispatchRegistrationStart();
      props
        .userOnBoardBasic(
          country,
          geonameId,
          parseInt(avatarId, 10),
          gender,
          bio,
          lang,
          parseInt(sport, 10),
          dob,
        )
        .then(async () => {
          setDataSubmit(true);
          setMsg(
            _lt(
              'Please wait, setting up your account. DO NOT refresh the page.',
            ),
          );
          props.occupation
            ? await props.userOccupation(props.occupation)
            : await props.userOccupation(2);
          await loginOldSite();
          await gtPostActivity('newuser');
          await receiveConnectRequests([
            3, 2127, 8336, 43551
          ]);
          if (!!uri) {
            props.updateUri(uri).then(() => {
              props.fetchUserDetails();
              props.dispatchRegistrationEnd();
              props.history.push(ROUTES.SIGN_UP_INVITES);
            });
          } else {
            props.fetchUserDetails();
            props.dispatchRegistrationEnd();
            props.history.push(ROUTES.SIGN_UP_INVITES);
          }
        })
        .catch((error) => {
          setError(error);
        });
    }
  };

  const onUriChange = debounce(async (newUri) => {
    const existingUri = uri;
    if (uriRegEx.test(newUri) && existingUri !== newUri) {
      setCheckingUri(true);
      const status = await checkUri(newUri);
      setCheckingUri(false);
      if (status === true) setUriError(false);
      else setUriError(status);
    }
  }, 1000);

  const onCityHandleChange = debounce(async (newCityQS) => {
    setLoadingCities(true);
    let newList = [];
    if (newCityQS.length > 2) newList = await autoSuggestCities(newCityQS);
    setCityList(newList || []);
    setLoadingCities(false);
  }, 1000);

  const onCityChange = (e, v) => {
    if (v) {
      setCityName(v.name);
      setGeonameId(v.value);
      setCountry(v.cc);
    }
  };

  const onChangeAvatar = async (newImage, newFile) => {
    setAvatar(newImage);
    setShowUploadDialog(false);
    setUploading(true);
    const res = await uploadFile(newFile);
    setUploading(false);
    if (res) {
      setAvatarId(res.data.media_id);
    }
  };

  const isInvalid =
    cityName === '' ||
    geonameId === '' ||
    country === '' ||
    gender === '' ||
    bio === '' ||
    lang === '' ||
    sport === '' ||
    dob === '';

  return (
    <Box display="flex" justifyContent="center" sx={classes.root}>
      <Paper elevation={0} sx={classes.formWrapper}>
        <Box sx={classes.formImage}></Box>
        <Box sx={classes.formContents}>
          <Dialog
            open={dialogOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {_lt('Finishing up')}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {_lt(
                  'It might take a few seconds to finish up your registration. Please do not refresh the page!',
                )}
              </DialogContentText>
            </DialogContent>
          </Dialog>
          <Grid container>
            <Grid item lg={12}>
              <Box>
                <form onSubmit={onSubmit}>
                  <Grid spacing={2} direction="row" container>
                    <Grid item lg={12}>
                      <Typography variant="h6" mb={1} pb={0} color="#4e4e7e">
                        {_lt(msg)}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                      <FormControl
                        sx={classes.avatar}
                        size="small"
                        variant="outlined"
                        error={
                          props.onBoardErrors && !!props.onBoardErrors.avatar_id
                        }
                      >
                        <Avatar
                          sx={{
                            border: '1px solid gainsboro',
                            width: 64,
                            height: 64,
                          }}
                          alt="Avatar"
                          src={avatar}
                          onClick={() => setShowUploadDialog(true)}
                        />
                        {props.onBoardErrors &&
                          !!props.onBoardErrors.avatar_id && (
                            <FormHelperText id="avatarId-text">
                              {_lt(props.onBoardErrors.avatar_id)}
                            </FormHelperText>
                          )}
                        <ImageUpload
                          roundShape={true}
                          show={showUploadDialog}
                          handleClose={() => setShowUploadDialog(false)}
                          handleUpload={(newImage, newFile) =>
                            onChangeAvatar(newImage, newFile)
                          }
                          header={_lt('Profile photo')}
                        />
                        {uploading && (
                          <Typography
                            variant="caption"
                            display="block"
                            color={'secondary'}
                          >
                            {_lt('Uploading...')}
                          </Typography>
                        )}
                        <Typography
                          variant="caption"
                          display="block"
                          onClick={() => setShowUploadDialog(true)}
                        >
                          {_lt('Please tap to add/edit your profile photo')}
                        </Typography>
                        {avatarId === null && (
                          <Typography
                            variant="caption"
                            display="block"
                            color={'primary'}
                            gutterBottom
                          >
                            {_lt('Uploading profile pic required to proceed')}
                          </Typography>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <FormControl
                        size="small"
                        variant="outlined"
                        error={
                          props.onBoardErrors && !!props.onBoardErrors.sport_id
                        }
                      >
                        <InputLabel
                          id="sport-select-label"
                          style={{ fontSize: '14px', overflow: 'hidden' }}
                        >
                          {_lt('Which sport do you associate to')}
                        </InputLabel>
                        <Select
                          sx={classes.formControlInput}
                          name="sport"
                          label={_lt('Which sport do you associate to')}
                          value={sport}
                          onChange={(e, v) => {
                            setSportName(v.props.children);
                            setSport(e.target.value);
                          }}
                          placeholder={_lt('Which sport do you associate to')}
                        >
                          {props.sports &&
                            Object.keys(props.sports).map((k, i) => (
                              <MenuItem
                                key={`sport-${k}`}
                                value={props.sports[k].sportId}
                              >
                                {props.sports[k].localname}
                              </MenuItem>
                            ))}
                        </Select>
                        {props.onBoardErrors &&
                          !!props.onBoardErrors.sport_id && (
                            <FormHelperText id="sport-text">
                              {_lt(props.onBoardErrors.sport_id)}
                            </FormHelperText>
                          )}
                      </FormControl>
                    </Grid>
                    {(!props.occupation || props.occupation === null) && (
                      <Grid item xs={12} lg={6}>
                        <FormControl variant="outlined">
                          <InputLabel id="occupation-label">
                            {_lt('Update your role')}
                          </InputLabel>
                          <Select
                            fullWidth
                            size="small"
                            name="first"
                            label="occupation"
                            value={props.occupation}
                            onChange={(e) =>
                              props.dispatchSetOccupation(e.target.value)
                            }
                            placeholder={_lt('Update your role')}
                          >
                            {siteRoles.map((x, i) => (
                              <MenuItem
                                size="small"
                                key={`o_${i}`}
                                value={x.value}
                              >
                                {x.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}
                    <Grid item xs={12} lg={6} sx={{ display: 'none' }}>
                      <FormControl
                        size="small"
                        variant="outlined"
                        error={!!uri && uriError}
                      >
                        <InputLabel id="uri-label" style={{ fontSize: '14px' }}>
                          {_lt('Your unique GT username')}
                        </InputLabel>
                        <OutlinedInput
                          sx={classes.formControlInput}
                          variant="outlined"
                          name="uri"
                          value={uri}
                          label={_lt('Your unique GT username')}
                          onChange={(e) => {
                            setUri(localTrim(e.target.value));
                            onUriChange(localTrim(e.target.value));
                          }}
                          placeholder={_lt('Your unique GT username')}
                          type="text"
                          error={!!uri && !!uriError}
                          helperText={_lt(uriError)}
                          endAdornment={
                            (!checkingUri && !uriError && (
                              <CheckCircleIcon style={{ color: green[500] }} />
                            )) ||
                            (!checkingUri && !!uri && uriError && (
                              <CancelIcon style={{ color: red[500] }} />
                            )) ||
                            (checkingUri && <CircularProgress size={20} />)
                          }
                        />
                        {uri && !!uriError && (
                          <FormHelperText id="uri-text">
                            {_lt(uriError)}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                      <FormControl variant="outlined" size="small">
                        <TextField
                          id="dob"
                          size="small"
                          type="date"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          value={dob}
                          onChange={(e) =>
                            checkDOBDateRange(e.target.value) &&
                            setDob(e.target.value)
                          }
                          label={_lt('Date of birth')}
                          placeholder={_lt('Date of birth')}
                        />
                        {props.agentErrors && !!props.agentErrors.dob && (
                          <FormHelperText id="dob-text">
                            {_lt(props.agentErrors.dob)}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" size="small">
                        <Autocomplete
                          size="small"
                          id="city-search"
                          defaultValue={cityName}
                          selectOnFocus
                          autoSelect
                          getOptionSelected={(option, value) =>
                            option.name === value.name
                          }
                          getOptionLabel={(option) => {
                            // Add "xxx" option created dynamically
                            if (option.value) {
                              return option.name;
                            }
                            // Regular option
                            return '';
                          }}
                          options={cityList}
                          filterOptions={(x) => x}
                          loading={loadingCities}
                          onChange={(e, v) => onCityChange(e, v)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={_lt('Type your city name')}
                              variant="outlined"
                              onChange={debouncedOnCityHandleChange}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {loadingCities ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <FormControl
                        size="small"
                        variant="outlined"
                        error={
                          props.onBoardErrors && !!props.onBoardErrors.gender
                        }
                      >
                        <InputLabel
                          id="gender-select-label"
                          style={{ fontSize: '14px' }}
                        >
                          {_lt('Gender')}
                        </InputLabel>
                        <Select
                          sx={classes.formControlInput}
                          name="gender"
                          label="Gender"
                          value={gender}
                          onChange={(e) => setGender(e.target.value)}
                          placeholder={_lt('Gender')}
                        >
                          <MenuItem key="neutral" value={0}>
                            {_lt('Neutral')}
                          </MenuItem>
                          <MenuItem key="female" value={1}>
                            {_lt('Female')}
                          </MenuItem>
                          <MenuItem key="male" value={2}>
                            {_lt('Male')}
                          </MenuItem>
                        </Select>
                        {props.onBoardErrors &&
                          !!props.onBoardErrors.gender && (
                            <FormHelperText id="gender-text">
                              {_lt(props.onBoardErrors.gender)}
                            </FormHelperText>
                          )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <FormControl
                        size="small"
                        variant="outlined"
                        error={
                          props.onBoardErrors && !!props.onBoardErrors.lang
                        }
                      >
                        <InputLabel
                          id="lang-select-label"
                          style={{ fontSize: '14px' }}
                        >
                          {_lt('Preferred Site Language')}
                        </InputLabel>
                        <Select
                          sx={classes.formControlInput}
                          name="lang"
                          label={_lt('Preferred Site Language')}
                          value={lang}
                          onChange={(e) => setLang(e.target.value)}
                          placeholder={_lt('Preferred Site Language')}
                        >
                          {props.langs &&
                            props.langs.map((x, i) => (
                              <MenuItem key={`lang-${i}`} value={x.lang_code}>
                                {x.lang_name}
                              </MenuItem>
                            ))}
                        </Select>
                        {props.onBoardErrors && !!props.onBoardErrors.lang && (
                          <FormHelperText id="lang-text">
                            {_lt(props.onBoardErrors.lang)}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl
                        size="small"
                        variant="outlined"
                        error={props.onBoardErrors && !!props.onBoardErrors.bio}
                      >
                        <TextField
                          sx={classes.formControlInput}
                          id="outlined-multiline-static"
                          label={_lt('Something about yourself')}
                          multiline
                          rows={4}
                          variant="outlined"
                          value={bio}
                          onChange={(e) => setBio(e.target.value)}
                          placeholder={_lt('Bio')}
                        />
                        {props.onBoardErrors && !!props.onBoardErrors.bio && (
                          <FormHelperText id="bio-text">
                            {_lt(props.onBoardErrors.bio)}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                      <ColoredButton
                        sx={classes.submitButton}
                        disabled={isInvalid}
                        type="submit"
                        variant="contained"
                        loading={loading}
                        bgcolor={red}
                        disableElevation
                      >
                        {_lt('Save')}
                      </ColoredButton>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  info: state.user.info,
  occupation: state.register.occupation,
  onBoardErrors: state.register.onBoardErrors,
  countries: state.common.countries,
  langs: state.common.langs,
  sports: state.common.sports,
  registrationStatus: state.register.registrationStatus,
});

const mapDispatchToProps = {
  userOccupation,
  userOnBoardBasic,
  fetchCountries,
  fetchLangs,
  fetchSports,
  checkUri,
  updateUri,
  fetchUserDetails,
  dispatchSetOccupation,
  dispatchRegistrationStart,
  dispatchRegistrationEnd,
};

const OnBoardBasicForm = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OnBoardBasic),
);

export default OnBoardBasicForm;
